<template>
  <el-pagination
    class="project-pagination"
    @size-change="changeSizeHandle"
    @current-change="currentChangeHandle"
    :current-page="currentPage"
    layout=" prev, pager, next"
    :pager-count="5"
    :page-size="size"
    :total="total"
    prev-text="上一页"
    next-text="下一页"
    background
  >
  </el-pagination>
</template>
<script>
export default {
  name: 'my-pagination',
  props: ['currentPage', 'size', 'total'],
  methods: {
    changeSizeHandle(val) {
      this.$emit('changeSizeHandle', val) // 改变每页显示的条数
    },

    // current-change用于监听页数改变，而内容也发生改变
    currentChangeHandle(val) {
      this.$emit('currentChangeHandle', val) // 改变默认的页数
    },
  },
}
</script>
<style lang="scss" >
.project-pagination,
.el-pagination {
  text-align: center;
  padding: 20px;

  .el-select .el-input {
    width: 100px;
    margin: 5px 5px;
  }
  .btn-prev,
  .btn-next,
  .el-pager span {
    height: 30px;
    padding: 0px 10px 4px 10px !important;
    color: #666;
    padding: 2px 10px !important;
    border-radius: 0 !important;
    border: 1px solid #dddddd;
    background-color: #fff !important;
  }
  .btn-prev,
  .btn-next,
  :disabled {
    color: #c0c4cc;
  }
  .btn-next:hover {
    .el-icon-arrow-right {
      color: #fff;
    }
  }
  .el-pager li {
    height: 30px;
    padding: 0px 10px;
    margin-left: 4px;
    margin-right: 4px;
    color: #999999;
    font-size: 14px !important;
    font-weight: 320;
    border-radius: 0 !important;
    background-color: #fff !important;
    border: 1px solid #dddddd;
    &:hover {
      color: #fff !important;
      background-color: #2abcb8 !important;
    }
    &.active {
      color: #fff;
      background-color: #2abcb8 !important;
    }
  }
}
.el-pager li.active + li {
  border: 1px solid #dddddd;
}
@media screen and (max-width: 600px) {
  .project-pagination {
    .el-pager {
      li {
        margin: 0 2px !important;
        min-width: 24px !important;
      }
    }
    .btn-prev,
    .btn-next {
      margin: 0 2px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my-pagination/index.vue